// @flow
import classNames from 'classnames';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faHourglassHalf } from '@fortawesome/pro-regular-svg-icons/faHourglassHalf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import RegisterLinkContainer from '../../components/RegisterLink/RegisterLinkContainer';
import styles from './CardCtaBanner.module.scss';

type Props = {
    approved: boolean,
    catalogId: number,
    declined: boolean,
    isAvailable: boolean,
    isCatalogOnly: boolean,
    pending: boolean,
    registered: boolean,
};

const CardCtaBanner = (props: Props) => {
    const {
        approved = false,
        catalogId,
        declined = false,
        isAvailable = false,
        isCatalogOnly = false,
        pending = false,
        registered = false,
    } = props;

    if (!isAvailable) {
        return null;
    } else if (approved) {
        return (
            <div className={classNames(styles.banner, styles.approved)}>
                <FontAwesomeIcon icon={faCheckCircle} />
                <FormattedMessage id="approved_to_bid" />
            </div>
        );
    } else if (declined) {
        return (
            <div className={classNames(styles.banner, styles.declined)}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
                <FormattedMessage id="registration_status_label.registration_declined" />
            </div>
        );
    } else if (pending && isCatalogOnly) {
        return (
            <div className={classNames(styles.banner, styles.pending)}>
                <FontAwesomeIcon icon={faHourglassHalf} />
                <FormattedMessage id="registration_status_label.catalog_only_registration_submitted" />
            </div>
        );
    } else if (pending) {
        return (
            <div className={classNames(styles.banner, styles.pending)}>
                <FontAwesomeIcon icon={faHourglassHalf} />
                <FormattedMessage id="registration_status_label.registration_pending" />
            </div>
        );
    } else if (!registered) {
        return (
            <div className={classNames(styles.banner, styles.register)}>
                <RegisterLinkContainer
                    className={styles['register-link']}
                    catalogId={catalogId}
                    isCatalogOnly={isCatalogOnly}
                />
            </div>
        );
    }

    return null;
};

export default React.memo<Props>(CardCtaBanner);
